/* eslint-disable @typescript-eslint/no-magic-numbers */
export interface IGroup {
  name: string;
  key: string;
  order: number;
  list: IList[];
}
export interface IList {
  title: string;
  icon: string;
  type: StaticType;
  content: string[];
}
export interface IStaticData {
  bottom: any; // 跟后端约定的底部状态
  content: {
    group: IGroup[];
  };
  header: string;
  redirect: string;
  user_agreement: {
    switch: number;
    color: string;
    check: number;
    select_color: string;
    txt_color: string;
    agreement_prefix: string;
    agreement_name: string;
    agreement_detail: Array<string>;
  };
}
export enum StaticType {
  IMAGE = 'image',
  VIDEO = 'video',
}
export const CHARGE_ID = 'charge_id';
export const TIME_RECORD_BEGIN = 'time_record_begin';
export const COUNT_DOWN = 2 * 24 * 60 * 60;
export const EXPIRES = (function() {
  const date = new Date();
  date.setDate(date.getDate() + 2);
  return date;
})();
